import {defineMessages} from "react-intl";

export default defineMessages({
    cdrHistoryPeriodIs: {id: "cdr.cdrHistoryPeriodIs", defaultMessage: "CDR history period is {count} month", description: 'Traffic, CDRFilters: CDR history period is {count} month'},
})